import React, { useEffect, useState } from 'react';
import Layout from '../../../components/common/pageLayout';
import { toast } from 'react-toastify';
import CategoryList from '../../../components/MasterData/Category/list';
import constant from '../../../constant';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { v3_categories, v3_category_visibility } from '../../../actions/v3/masterData';
import { replacePageState } from '../../../utils';

const List = (props) => {
    const location = useLocation();
    const { page } = location.state || {};
    const [data, setData] = useState(null);
    const [currentPage, setCurrentPage] = useState(page || 1);
    const [limit, setLimit] = useState(10);

    useEffect(() => {
        v3_categories(currentPage, limit).then((res) => {
            if (res.status) {
                setData(res.result);
                replacePageState(props.history, constant.Authedcomponent.listCategoryMasterData.url, {
                    page: currentPage
                });
            } else {
                toast.error(res.error);
            }
        });
    }, [currentPage, limit]);

    const onChangeVisibility = (record) => {
        const newStatus = !record.IS_ACTIVE;

        v3_category_visibility(record.ID, newStatus).then((res) => {
            if (res.status) {
                setData(prevState => ({
                    ...prevState,
                    categories: prevState.categories.map(item => {
                        if (item.ID === record.ID) {
                            return {
                                ...item,
                                IS_ACTIVE: newStatus
                            };
                        }
                        return item;
                    })
                }));

                toast.success(res.result.message);
            } else {
                toast.error("Failed to update category visibility");
            }
        }).catch((err) => {
            console.error(err);
            toast.error("An error occurred while updating category visibility");
        });
    };

    return (
        <Layout title={'Category Master'}>
            {data && (
                <CategoryList
                    onChangeVisibility={onChangeVisibility}
                    limit={limit}
                    data={data}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
            )}
        </Layout>
    );
};

export default List;
